module.exports = __webpack_public_path__ + "static/media/minusIcon.29a4c3da.svg";